// ======================================================================
// File Name       : userAttribute
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import * as ActionTypes from '../constants/actionTypes/userAttribute';


const INITIAL_STATE = {
  userAttributes: {}, // ex: {1: "user attribute 1"}
  editingUserAtribute: {}, // ex: {1: "user attribute 1"}
};

export default function userAttribute(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.USER_ATTRIBUTE_RECEIVE_LIST: {
      const { userAttributeList } = action;
      const userAttributes = userAttributeList.reduce((acc, cur) => {
        const { userAttributeKeyNum } = cur;
        acc[userAttributeKeyNum] = cur.userAttribute;
        return acc;
      }, {});

      return {
        ...state,
        userAttributes,
      };
    }

    case ActionTypes.USER_ATTRIBUTE_INIT_EDITING: {
      return {
        ...state,
        editingUserAtribute: { ...state.userAttributes },
      };
    }

    case ActionTypes.USER_ATTRIBUTE_RECEIVE_EDITING: {
      const { payload } = action;
      return {
        ...state,
        editingUserAtribute: { ...state.editingUserAtribute, ...payload },
      };
    }

    default:
      return state;
  }
}
